import React from 'react';
import Reveal from '../Reveal/Reveal';

const TerminalBlock = () => (
  <Reveal className="terminal" aria-hidden="true">
    <div className="terminal-bar">
      <span className="t-dot t-r" />
      <span className="t-dot t-y" />
      <span className="t-dot t-g" />
      <em className="t-title">OrderService.cs — codeinventiv/api</em>
    </div>
    <pre className="terminal-body">
      <span className="c-mut">{'// Clear ownership. Predictable delivery.'}</span>
      {'\n'}
      <span className="c-key">public sealed class</span> <span className="c-cls">OrderService</span> :{' '}
      <span className="c-cls">IOrderService</span>
      {'\n'}
      {'{'}
      {'\n'}
      {'  '}
      <span className="c-key">private readonly</span> <span className="c-cls">IRepository</span>
      &lt;<span className="c-cls">Order</span>&gt; _orders;
      {'\n'}
      {'  '}
      <span className="c-key">private readonly</span> <span className="c-cls">ILogger</span>
      &lt;<span className="c-cls">OrderService</span>&gt; _log;
      {'\n'}
      {'\n'}
      {'  '}
      <span className="c-key">public async</span> <span className="c-cls">Task</span>
      &lt;<span className="c-cls">Result</span>&lt;<span className="c-cls">Order</span>&gt;&gt;{' '}
      <span className="c-fn">PlaceAsync</span>(
      {'\n'}
      {'      '}
      <span className="c-cls">PlaceOrderCmd</span> cmd, <span className="c-cls">CancellationToken</span> ct)
      {'\n'}
      {'  '}
      {'{'}
      {'\n'}
      {'    '}
      <span className="c-key">using var</span> _ = _log.<span className="c-fn">BeginScope</span>(
      <span className="c-str">&quot;order.place&quot;</span>);
      {'\n'}
      {'\n'}
      {'    '}
      <span className="c-key">var</span> order = <span className="c-cls">Order</span>.<span className="c-fn">Create</span>(cmd);
      {'\n'}
      {'    '}
      <span className="c-key">await</span> _orders.<span className="c-fn">AddAsync</span>(order, ct);
      {'\n'}
      {'\n'}
      {'    '}
      <span className="c-key">return</span> <span className="c-cls">Result</span>.<span className="c-fn">Ok</span>(order);
      {'\n'}
      {'  '}
      {'}'}
      {'\n'}
      {'}'}
    </pre>
  </Reveal>
);

export default TerminalBlock;
